<template>
  <div class="main-tabela">
    <header class="header-tabela">
      <div class="logo">
        <img src="../assets/LogoZecon.png" alt="" />
      </div>
      <div class="back-to-site">
        <a href="/" class="site-link">
          <img src="../assets/IconeHome.png" alt="Home" class="home-icon" />
          Voltar ao Site
        </a>
      </div>
    </header>
    <div class="tabela">
      <b-table striped hover :items="formattedItems" :fields="fields"></b-table>
    </div>
    <Bottom class="bottom-fixed" />
  </div>
</template>

<script>
import Bottom from "./Bottom.vue";
import { api } from "../services/api/Api.js";

export default {
  name: "Tabela",
  components: {
    Bottom
  },
  data() {
    return {
      fields: [
        "time",
        "velocidade",
        "abertura_1",
        "abertura_2",
        "temp_mancal_1",
        "temp_mancal_2"
      ],
      items: []
    };
  },
  computed: {
    formattedItems() {
      // Crie uma cópia dos itens e formate a propriedade 'time'
      return this.items.map(item => ({
        ...item,
        time: this.formatData(item.time)
      }));
    }
  },
  mounted() {
    // Faça uma chamada à sua API ou endpoint do back-end
   api.get("/listar")
      .then(response => {
        // Atribua os dados obtidos à propriedade items
        this.items = response.data.bombas;
      })
      .catch(error => {
        console.error("Erro ao obter os dados:", error);
      });
  },
  methods: {
    formatData(data) {
      const date = new Date(data);
      return date.toLocaleString();
    }
  }
};
</script>

<style scoped>
.main-tabela {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  background-color: white;
}

.header-tabela {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #343333;
  color: white;
  width: 100%;
  height: 9vh;
  box-sizing: border-box;
  z-index: 1;
}

.logo {
  padding: 0 6vw;
  display: flex;
  align-items: center;
}

.logo img {
  height: 6vh;
}

.back-to-site {
  padding: 0 6vw;
  display: flex;
  align-items: center;
}

.site-link {
  color: #f5f5f5;
  text-decoration: none;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  font-weight: 400;
  display: flex;
  align-items: center;
}

.home-icon {
  width: 1em;
  height: 1em;
  margin-right: 0.5em;
}

.tabela {
  margin-top: 9vh;
  max-height: 85vh;
  overflow-y: auto;
}

.bottom-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}

@media only screen and (max-width: 992px) {
  .logo img {
    height: 2.5em;
  }

  .site-link {
    font-size: 16px;
  }

  .home-icon {
    width: 0.9em;
    height: 0.9em;
    margin-right: 0.4em;
  }
}
</style>
